import React, { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
  Flex,
  useTheme,
} from '@chakra-ui/react';
import AleaCloseIcon from '../../icons/AleaCloseIcon.tsx';
import AleaCheckIcon from '../../icons/AleaCheckIcon.tsx';

interface AleaConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  children?: React.ReactNode;
  onCancelButtonClick?: () => void;
  hideCancelButton?: boolean;
  titleColor?: string;
}

const AleaConfirmModal: React.FC<AleaConfirmModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  onConfirm,
  children,
  onCancelButtonClick,
  hideCancelButton,
  titleColor,
}) => {
  const theme = useTheme();

  // Notify header about modal state changes
  useEffect(() => {
    const event = new CustomEvent('alea-global-modal-open', { detail: isOpen });
    window.dispatchEvent(event);
  }, [isOpen]);

  const handleCancelButtonClick = () => {
    if (onCancelButtonClick) {
      onCancelButtonClick();
    } else {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent minWidth="300px" maxWidth="342px" minHeight="74px" borderRadius="20px" p="0">
        <ModalHeader
          fontSize="20px"
          fontWeight={500}
          textAlign="center"
          pt="25px"
          pb="0"
          color={titleColor || 'black'}
        >
          {title}
        </ModalHeader>
        
        {(description || children) && (
          <ModalBody textAlign="center" color="black" pt="10px" pb="0" px="25px">
            {description && <Text>{description}</Text>}
            {children}
          </ModalBody>
        )}
        
        <ModalFooter pt="25px" pb="25px" px="25px">
          <Flex justifyContent="center" width="100%" alignItems="center" gap="10px">
            {!hideCancelButton && (
              <Button
                colorScheme="alea"
                variant="outline"
                onClick={handleCancelButtonClick}
                h="50px"
                w="100px"
                borderRadius="20px"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <AleaCloseIcon color={theme.colors.alea[500]} />
              </Button>
            )}

            {/* Confirm Button */}
            <Button
              colorScheme="alea"
              variant="solid"
              onClick={onConfirm}
              h="50px"
              w="100px"
              borderColor="alea.500"
              borderRadius="20px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <AleaCheckIcon size={29} color='white' />
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AleaConfirmModal;